import React from 'react';
import styled from 'styled-components';
import { getFaqAction } from '../../modules/cs/customserviceModule';

import {isMobileOnly} from 'react-device-detect';

const EsReqDvryInfoBlock = styled.div`
  ${isMobileOnly&&`
  td {
    position:unset;
    &:first-of-type {width:30vw;text-align:center;font-size:0.8em;word-break: keep-all;}
  }`};
  
`;

const EsReqDvryInfo = ({ detailInfo, dsrd_date_format, rqst_status }) => {


    // const getDeliveryInfo = () => {

    //     // 배송 가능
    //     if (detailInfo.masterinfo.is_non_dlvry === 0) {
    //         // 차등 배송비
    //         if (detailInfo.brandinfo.is_dlvry_ref) {
    //             return ("- 배송 가능 ( 차등 배송비 : 상세페이지 참조 )");
    //         } else {
    //             return ("- 배송 가능 (기본 배송비 : (" + detailInfo.brandinfo.dlvry_fee + ")");
    //         }

    //     } else {
    //         return ("- 배송 불가");
    //     }
    // }

    const getDlvryDate = () => {
        let strDate = "-";


        if (detailInfo.userinfo.dlvry_date !== null) {
            strDate = detailInfo.userinfo.dlvry_date.slice(0, 10);
        }

        return strDate;
    }

    const getAnswerStr = () => {
        if (detailInfo.userinfo.es_answer === null ||
            detailInfo.userinfo.es_answer === undefined ||
            detailInfo.userinfo.es_answer === "") {
            return "-"
        } else {
            return detailInfo.userinfo.es_answer;
        }
    }

    const getQuestionStr = () => {
        if (detailInfo.userinfo.es_question === null ||
            detailInfo.userinfo.es_question === undefined ||
            detailInfo.userinfo.es_question === "") {
            return "-"
        } else {
            let errText = detailInfo.userinfo.es_question;;
            if(errText !== null  && typeof(errText) === "string" && errText.length > 0  && errText.indexOf("\n") > -1){
                let text = "";
                text = errText.split("\n").map(function(item, idx) {
                    
                    return (
                        <span key={idx}>
                            {item}
                            <br/>
                        </span>
                     )
                })
                return text;
            } else {
                return errText;
            }
        }
    }

    const getInstallChrg = () => {

        let installChrgAnswer = detailInfo.userinfo.install_chrg_answer === "" ? '-' : detailInfo.userinfo.install_chrg_answer;
        //const installChrgAnswer = detailInfo.userinfo.is_install_chrg?"비용 확인 해주세요":"비용 확인하지 않습니다";
        if (rqst_status === '050102' || rqst_status === '050103' || rqst_status === '050104' 
        || rqst_status === '050108' || rqst_status === '050109' || rqst_status === '050110') {
            installChrgAnswer = detailInfo.userinfo.is_install_chrg?"비용 확인 해주세요":"비용 확인하지 않습니다";
        }

        return (<tr>
            <td className="gray border_bottom">설치 및 조립 요청</td>
            <td colSpan="3" className="border_bottom">
                {installChrgAnswer}
            </td>
        </tr>);
    }


    const getQuestion = () => {

        if (getQuestionStr() === "-") {
            return null;
        }

        return (<tr>
            <td rowSpan="2" className="gray border_bottom">문의 사항</td>
            <td colSpan="3" className="border_bottom">
                <p className="question-text">{getQuestionStr()}</p>
            </td>
        </tr>);
    }

    const getAnswer = () => {

        if (getQuestionStr() === "-") {
            return null;
        }

        return (<tr>
            <td colSpan="3" className="border_bottom">
                <p className="answer_icon-text">
                    {getAnswerStr()}
                </p>
            </td>
        </tr>)
    }

    const getHouseType = () => {

        let areatype = detailInfo.userinfo.area_type === '055202' ? "전용" : "공급";

        return (<tr>
            <td className="gray">평수</td>
            <td>
                {detailInfo.userinfo.area_size === '0' ? "-" : areatype}
                {detailInfo.userinfo.area_size === '0' ? "" : detailInfo.userinfo.area_size}
            </td>
            <td className="gray">주거 형태</td>
            <td>{detailInfo.userinfo.code_nm === null ? "-" : detailInfo.userinfo.code_nm}</td>
        </tr>)
    }

    return (
        <EsReqDvryInfoBlock>

            <div className="default-table margin_b-120">
                <h3 className="dt-title">배송 정보 및 추가 사항</h3>
                {
                    detailInfo === null ? "" :

                        isMobileOnly?
                          <table>
                            <tbody>
                            <tr>
                                <td className="gray">희망 배송일</td>
                                <td>
                                    <p className="margin_b-10">
                                        <span className="font-mont">{dsrd_date_format}</span>
                                    </p>

                                    {!detailInfo.userinfo.dlvry_date&&<p className="ess_text">
                                        ※ 확정된 날짜가 아닙니다. 희망 배송일자이므로 업체와 상의후 확정 지으시길 바랍니다.
                                    </p>}

                                </td>
                            </tr>
                            {detailInfo.userinfo.dlvry_date&&<tr>
                                <td className="gray">배송가능 일자</td>
                                <td>
                                    <p className="margin_b-10">
                                        <span className="font-mont">{getDlvryDate()}</span>
                                    </p>
                                    <p className="ess_text">※ 예상 배송일입니다. 주문일 기준으로 배송일이 변동될 수 있습니다.</p>
                                </td>
                            </tr>}
                            <tr>
                                <td className="gray">배송 지역</td>
                                <td colSpan="3">
                                        {detailInfo.userinfo.addr1} , {detailInfo.userinfo.addr2}
                                </td>
                            </tr>
                            <tr>
                                <td className="gray">평수</td>
                                <td>
                                    {detailInfo.userinfo.area_size === '0' ? "-" : `${detailInfo.userinfo.area_type === '055202' ? "전용" : "공급"} ${detailInfo.userinfo.area_size}` }
                                </td>
                            </tr>
                            <tr>
                                <td className="gray">주거 형태</td>
                                <td>{detailInfo.userinfo.code_nm === null ? "-" : detailInfo.userinfo.code_nm}</td>
                            </tr>
                            {getInstallChrg()}
                            {getQuestion()}
                            {getAnswer()}
                            </tbody>
                        </table>
                          :
                          <table>
                            <colgroup>
                                <col width="180px;" />
                                <col width="410px;" />
                                <col width="180px;" />
                                <col width="410px;" />
                            </colgroup>

                            <tbody>
                            <tr>
                                <td className="gray">희망 배송일</td>
                                <td colSpan="3">
                                    <p className="margin_b-10">
                                        <span className="font-mont">{dsrd_date_format}</span>
                                    </p>

                                    {!detailInfo.userinfo.dlvry_date&&<p className="ess_text">
                                        ※ 확정된 날짜가 아닙니다. 희망 배송일자이므로 업체와 상의후 확정 지으시길 바랍니다.
                                    </p>}

                                </td>
                            </tr>
                            {detailInfo.userinfo.dlvry_date&&<tr>
                                <td className="gray">배송가능 일자</td>
                                <td colSpan="3">
                                    <p className="margin_b-10">
                                        <span className="font-mont">{getDlvryDate()}</span>
                                    </p>
                                    <p className="ess_text">※ 예상 배송일입니다. 주문일 기준으로 배송일이 변동될 수 있습니다.</p>
                                </td>
                            </tr>}
                                <tr>
                                    <td className="gray border_black">배송 지역</td>
                                    <td colSpan="3" className="border_black">
                                        <p>
                                            {detailInfo.userinfo.addr1} , {detailInfo.userinfo.addr2}
                                        </p>
                                        {/* #2719 - 삭제 요청  <p className="padding_l-10 margin_b-10">
                                            {getDeliveryInfo()}
                                        </p> */}
                                        {/* <p className="ess_text">
                                            ※ 묶음 배송 불가
                                            </p> */}
                                    </td>
                                </tr>
                                {getHouseType()}
                                {getInstallChrg()}
                                {getQuestion()}
                                {getAnswer()}
                            </tbody>
                        </table>
                }
            </div>


        </EsReqDvryInfoBlock>
    );
};

export default EsReqDvryInfo;
